<template>
  <div class="gc-toast-container">
      <div
          :class="['gc-toast', `toast-${type}`]"
          role="alert"
          aria-live="assertive"
      >
          <div class="gc-toast-header">
              <div class="toast-message">
                  <p>{{ message }}</p>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: {
    type: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
    },
  },
  data() {
    return {
      getIcon: this.getIconComputed,
    };
  },

  mounted() {
    setTimeout(() => {
        this.$emit("remove-toast");
    }, 3000);
  },

  methods: {
    getIconComputed() {
      let computedIcon = "refresh"
      switch (this.type) {
          case "success":
              computedIcon = "tick"
              break
          case "error":
              computedIcon = "exclamation"
              break
          case "info":
              computedIcon = "bell"
              break
          default: computedIcon = "bell"
      }
      return computedIcon
    },
    emit(event, ...args) {
      this.$emit(event, ...args);
    },
  },
};
</script>

<style
  lang="scss"
  scoped
>
.gc-toast-container {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
}

.gc-toast {
  width: 372px;
  height: 100px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  padding: 16px;
  margin-bottom: 40px;
  animation: slideIn 0.2s;
}

.gc-toast-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.gc-toast-close-button-wrapper {
  margin-left: auto;
}

.gc-toast-title {
  flex-grow: 1;
  font-size: 18px;
  color: white;
}

.toast-message {
  font-size: 16px;
  color: white
}

.gc-toast-close-button {
  margin-left: 12px;
  background: none;
  border: none;
  cursor: pointer;
  box-shadow: 0;

  &:hover {
      box-shadow: none;
  }

  &:focus {
      box-shadow: none;
  }
}

.toast-success {
  background-color: #16A34A,
}

.toast-error {
  background-color: #EF4444;
}

.toast-warning {
  background-color: #1D4ED8;
}

.toast-info {
  background-color: #E2E8F0;
}

@keyframes slideIn {
  from {
      opacity: 0;
      transform: translateY(50%);
  }

  to {
      opacity: 1;
      transform: translateY(0);
  }
}
</style>
